export function init_header() {
  window.setTimeout(function () {
    $('body').removeClass('loading');
  }, 300);

  $('#toggleNav').on('click', function (e) {
    let header_nav = $('.header__nav');
    $('.nav__logo').toggle();
    $('.menu-lang-switcher-container').toggle();
    if ($(this).hasClass('nav-active')) {
      header_nav.fadeOut('fast');
      header_nav.width('0');
      $('.home.page-template').css('overflow-y', 'auto');
    } else {
      header_nav.fadeIn('fast');
      header_nav.width('calc(100% - 40px)');
      header_nav.css('display', 'flex');
      $('.home.page-template').css('overflow-y', 'hidden');
    }
    $('#toggleNav').toggleClass('nav-active');
    e.stopPropagation();
  });

  $('.menu-item').on('click', function (e) {
    $(e.target).toggleClass('active');
  });

  $(window).on('scroll', () => {
    if ($(window).width() >= 1200) {
      if ($('.header-rooms-container').css('display') == 'none') {
        $('.header-rooms-container').css('top', '66px');
      } else if ($('.header-rooms-container').css('display') == 'block') {
        if ($(window).scrollTop() >= 50) {
          $('.header-rooms-container').css('top', '0');
        } else {
          $('.header-rooms-container').css('top', '66px');
        }
      }
    }
  });
}
